import { setCookie, hasCookie, getCookie } from "./cookies";

export function persistFilter(name: string, filter: object, namespace = "") {
	setCookie(`${namespace}_${name}`, JSON.stringify(filter), 1000);
}

export function hydrateFilter<T>(name: string, defaultFilter: T, namespace = ""): T {
	const cookieName = `${namespace}_${name}`;
	if (hasCookie(cookieName)) {
		const serializedFilter = getCookie(cookieName);
		return JSON.parse(serializedFilter) as T;
	}

	return defaultFilter as T;
}
